
export const Roles = {
    AddRole: 'role/createRole',
    RolesPagination: 'role/getAllRoles?',
    EditRole: 'role/updateRoleById/',
    DeleteRole: 'role/deleteRoleById/'
}

export const Company = {
    AddCompany: 'company/createCompany',
    getCompany: 'company/createCompany?',
    deleteCompany: 'company/deleteCompanyById/',
    EditCompany: 'company/updateCompany/'
}

export const User = {
    RegisterUser: 'user/registeruser',
    LoginUser: 'user/login',
    GetAllAdminUser: 'user/getAdminsForSuperAdmin/',
    UpdateAdminUser: 'user/updateUserById/',
    DeleteUser: 'user/deleteUserById/',
}

export const Employes = {
    AssignUsers: 'user/getUsers?'
}

export const EmployeeReport = {
    EmployeeReport: 'callLog/getUserEfficiency?',
    UserReport: 'report/getUserReport?',
    TeamHeirachy: 'report/getUserHierarchy',
    getUserStatus: 'report/getUserStatus'
}

export const Leads = {
    AddLeads: 'lead/createLead',
    UploadCSV: 'lead/bulkLeadUpload',
    bulkLeadUploadwStatus: 'lead/bulkLeadUploadwStatus',
    getleads: 'lead/getLeadForUser?',
    UpdateLeads: 'lead/updateLead/',
    DeleteLeads: 'lead/deleteLeadById/',
    DeleteMultipleLeads: 'lead/deleteMultipleLead',
    AssignLeads: 'lead/assignUserForMultiLeads'
}

export const Leads2 = {
    getallLeads: 'lead/getLead?'
}

export const Profile = {
    EditProfile: 'user/updateUserById/',
    ChangePassword: 'user/changePasswordSendOtp',
    ConfirmPassword: 'user/confirmPasswordOtp',
    ForgotPassword: 'user/forgotPasswordSendOtp'
}

export const Groups = {
    AddGroup: 'group/createGroup',
    GroupsByComapny: 'group/getGroupsByCompany?',
    editGroupURL: 'group/updateGroup/',
    DeleteGroup: 'group/deleteGroupById/',
    GetLeadsByGroups: 'group/getLeadsByGroupId/'
}

export const CallLogs = {
    AddCallLogs: 'callLog/addLeadCallLog',
    updateLeadCallLogById: 'callLog/updateLeadCallLogById/',
    updateLeadAndCallLog: 'callLog/updateLeadAndCallLog'

}

export const LeadsForUsers = {
    leadsForUser: 'lead/getLeadForUser?'
}

export const LeadsHistory = {
    leadsHistory: 'group/getLeadUserHistory/'
}

export const GetCallLogs = {
    getCallLogs: 'callLog/getCallLogsByLeadId/',
    getUserTalkTime:'callLog/getUserTalkTime'
}


export const LeadsGroups = {
    leadsGroupsURL: 'group/assignLeadsToGroup'
}

export const GetLeadsCount = {
    getLeadsCount: 'lead/getLeadsCount?'
}

export const GetAllDashboardLeadsURL = {
    getAllDashboardLeads: 'lead/getDashBoardLeads?'
}

export const TeamLeadMappingURL = {
    teamLeadMappingURL: 'lead/teamLeadMapping'
}

export const Mispunch = {
   getAllMispunch : 'mispunch/getAllMispunch',
   deleteMispunch : 'mispunch/deleteMispunchById/',
   createMispunch: 'mispunch/createMispunch',
   updateMispunch: 'mispunch/updateMispunchById/'
}

export const Attendence ={
    getAllSubordinatesAttendence : 'attendence/getAllSubordinatesAttendence',
    getALLOwnAttendence : 'attendence/getAllAttendence'
}


export const AttendenceURL = {
    createAttendence: 'attendence/createAttendence',
    updateAttendenceByUserId: 'attendence/updateAttendenceByUserId',
    updateBreakByUserId: 'attendence/updateBreakByUserId',
    getAttendenceByUserId: 'attendence/getAttendenceByUserId',
    getSingleAttendence: 'attendence/getLatestSessionByUserId',
    getLatestBreak: 'attendence/getLatestBreakByUserId',
}

export const notification = {
    getAllNotification:'notification/getAllNotification'
}